module.exports = __webpack_public_path__ + "static/media/RB_MonoWhite_RGB.357978db.svg";